// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__FwWp1 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_radioWrapper__dqrL1 {
  display: flex;
  gap: 24px;
}
@media (max-width: 992px) {
  .styles_radioWrapper__dqrL1 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .styles_radioWrapper__dqrL1 {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/reflectionContent/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;ACgBE;EDjBF;IAKI,aAAA;IACA,qCAAA;EAAF;AACF;ACsBE;ED7BF;IAUI,0BAAA;EACF;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.radioWrapper {\n  display: flex;\n  gap: 24px;\n\n  @include lg {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @include sm {\n    grid-template-columns: 1fr;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__FwWp1`,
	"radioWrapper": `styles_radioWrapper__dqrL1`
};
export default ___CSS_LOADER_EXPORT___;
